module.exports = __webpack_public_path__ + "img/SKMJ_saferoad3.fbb13e2e.jpg";